<template>
  <form class="fullmakt-form">
    <h2 class="registration__subtitle">Giltighetstid</h2>

    <span class="fullmakt-form__input" >
      <label class="label" for="one">
        <input type="radio" id="one" value="one" v-model="picked">
        <span class="label__checkmark"></span>
        Tillsvidare
      </label>
    </span>

    <span class="fullmakt-form__input" >
      <label class="label" for="validto">
        <input type="radio" id="validto" value="validTo" v-model="picked">
        <span class="label__checkmark"></span>
        Till och med
      </label>
      <input type="date" v-model="date" :disabled="picked !== 'validTo'">
    </span>
  </form>
</template>

<script>
export default {
  name: 'FullmaktTimeSelector',
  prop: [ 'validTo' ],
  data () {
    return {
      picked: 'one',
      date: ''
    }
  },
  watch: {
    validTo: {
      handler (value) {
        if(value === null) {
          this.picked = 'one'
          this.date = ''
        } else {
          this.picked = 'validTo'
          this.date = value
        }
      }
    },
    picked () {
      this.$emit('update:validTo', this.picked === 'one' ? null : this.date)
    },
    date () {
      this.$emit('update:validTo', this.picked === 'one' ? null : this.date)
    }
  }
}
</script>

<style lang="scss" scoped>
.fullmakt-form {
  display: flex;
  flex-direction: column;

  &__input {
    margin-top: 10px;
    display: flex;
    flex-direction: column;

    > input[type="date"] {
      margin-top: 3px;
      padding: 5px;
      width: 100%;
    }

    @include breakpoints(small) {
      flex-direction: row;

      > input[type="date"] {
        width: 50%;
      }
    }
  }
}

.label {
  display: flex;
  justify-content: center;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 1rem;
  -webkit-user-select: none;
    -moz-user-select: none;
      -ms-user-select: none;
        user-select: none;

  > input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  &__checkmark {
    position: absolute;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;

    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }

  &:hover input ~ .label__checkmark {
    background-color: #ccc;
  }

  input:checked ~ .label__checkmark {
    background-image: url('../../assets/svg/checkmark.svg');
    background-size: cover;
    background-repeat: no-repeat;
  }

  input:checked ~ .label__checkmark:after {
    display: block;
  }
}
</style>
